<p-accordion [value]="expanded ? '0' : 'none'" class="accordion-detail" [transitionOptions]="'0ms'">
  <p-accordion-panel value="0">
    <p-accordion-header>{{ title }}</p-accordion-header>
    <p-accordion-content>
      <div class="row g-2 p-2 indicators-container" [class.indicators-refreshing]="loading && loadedOnce"
        [class.justify-content-center]="charts.length === 1">
        <div *ngFor="let chart of charts; trackBy: trackByTitle" class="col-12 col-lg-6 fieldset-indicator">
          <p-fieldset [legend]="chart.title" class="d-block h-100" styleClass="h-100">
            <div class="chart-container" [class.chart-container-loading]="loading && !loadedOnce"
              [style.min-height.px]="containerHeight" [ngSwitch]="chart.type">
              <app-custom-donut-chart *ngSwitchCase="chartTypes.donut" [labels]="chart.labels" [values]="chart.values"
                [colors]="chart.colors ?? []" [total]="chart.total ?? null"
                [totalLabel]="chart.totalLabel ?? 'Total'" [height]="chartHeight"></app-custom-donut-chart>
              <app-custom-bar-chart *ngSwitchCase="chartTypes.bar" [labels]="chart.labels" [values]="chart.values"
                [colors]="chart.colors ?? []" [height]="chartHeight"></app-custom-bar-chart>
            </div>
          </p-fieldset>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>